import { createMachine, assign } from 'xstate';
import { uuid } from 'vue-uuid';
import {validZipCodesSolar} from "@/data/validZipCodesPv";
import {validZipCodesWP} from "@/data/validZipCodesWp";


import { transformContactFormDataForApi } from '@/utils/apiTransformer';

// Importe der ausgelagerten Aktionen
import {
    setStateHistory,
    sendDataToGateway,
    sendVlinkDataAction,
    updateBuildingTypeData,
    updateOwnerData,
    updateAlreadyBuiltData,
    //updateBuildingAgeData,
    storeAddressData,
    updatePlannedReplacementData,
    storeContactFormData,
    clearErrorMessage,
    updateMonumentData,
    //updateRenovationData,
    updateNumberPersonsData,
    updateHeatingLocationData,
    updateWishPVData,
    updateAppointmentTypeData,
    sendTrackingPostMessage,
    trackConversion,
    //redirectParentDirectly,
} from '@/utils/workflowMachineActions';
import {buildingYearThresholds} from "@/data/buildingAgeData";
export const workflowMachine = createMachine({
    id: 'workflow',
    initial: 'buildingTypeQuestion',
    context: {
        appSessionId: uuid.v4(),
        fromState: "Geladen",
        toState: "Frage: Gebäudetyp",
        fromMachineState: "Initial", // Maschinenzustand
        toMachineState: "buildingTypeQuestion", // Maschinenzustand
        qualifikation: {
            buildingType: { apiDefinition: null, apiValue: null, },
            owner: { apiDefinition: null, apiValue: null, },
            //buildingAge: { apiDefinition: null, apiValue: null, },
            alreadyBuilt: { apiDefinition: null, apiValue: null, },
            planned_replacement: { apiDefinition: null, apiValue: null, },
            monument: { apiDefinition: null, apiValue: null, },
            //renovation: { apiDefinition: null, apiValue: null, },
            number_persons: { apiDefinition: null, apiValue: null, },
            heating_location: { apiDefinition: null, apiValue: null, },
            wishPV: {apiDefinition: null, apiValue: null,},
        },
        formData: {
            building: {
                zip: null, city: null, street: null, houseNumber: null,
                type: null, owner: false, year: null, planned_replacement: null, /*age: null,*/
                already_built: false,
                monument: null, /*renovation: null,*/  number_persons: null, heating_location: null,
                wish_pv: null,
                appointment: null,
            },
            contactForm: null,
            contactFormApiData: null,
            submissionResultData: null,
        },
        transitionCount: 0,
        errorMessage: null,
        crossdomainId: '',
        levetoSource: '',
        levetoMedium: '',
        levetoChannel: 'ON',
        apiFieldErrors: null,
        vertriebskanal: '',
    },
    on: {
        CLEAR_API_ERRORS: {
            actions: assign({apiFieldErrors: null, errorMessage: null}), // Setzt alle API-Fehler auf null
        },
    },
    states: {
        buildingTypeQuestion: {
            on: {
                UPDATE_SELECTED_BUILDING_TYPE: { actions: updateBuildingTypeData, },
                NEXT: [
                    { actions: updateBuildingTypeData, target: 'ownerQuestion', guard: 'isBuildingTypeAvailable', },
                    { actions: updateBuildingTypeData, target: 'buildingTypeNotAvailable', },
                ],
            },
        },
        ownerQuestion: {
            on: {
                UPDATE_SELECTED_OWNER_ANSWER: { actions: updateOwnerData, },
                NEXT: [
                    { actions: updateOwnerData, target: 'alreadyBuiltQuestion', guard: 'isOwnerAvailable', },
                    { actions: updateOwnerData, target: 'ownerNotAvailable', },
                ],
                BACK: { target: 'buildingTypeQuestion', },
            },
        },
        alreadyBuiltQuestion: {
            on: {
                UPDATE_SELECTED_ALREADY_BUILT_ANSWER: {actions: updateAlreadyBuiltData},
                NEXT: [
                    { actions: updateAlreadyBuiltData, guard: 'isAlreadyBuiltAvailable', target: 'zipCodeQuestion', },
                    { actions: updateAlreadyBuiltData, target: 'buildingYearNotAvailable', },
                ],
                BACK: { target: 'ownerQuestion', },
            },
        },
        zipCodeQuestion: {
            on: {
                NEXT: [
                    { actions: storeAddressData, target: 'monumentQuestion', guard: 'isZipCodeValid', },
                    { actions: storeAddressData, target: 'zipCodeNotAvailable', },
                ],
                BACK: { target: 'alreadyBuiltQuestion', },
            },
        },
        monumentQuestion: {
            on: {
                UPDATE_SELECTED_MONUMENT_ANSWER: {actions: updateMonumentData},
                NEXT: [
                    { actions: updateMonumentData, guard: 'isMonumentAvailable', target: 'heatingLocationQuestion', },
                    { actions: updateMonumentData, target: 'monumentNotAvailable' },
                    ],
                BACK:{ target: 'zipCodeQuestion', },
            }
        },
        heatingLocationQuestion: {
            on: {
                UPDATE_SELECTED_HEATING_LOCATION_ANSWER: { actions: updateHeatingLocationData, },
                NEXT: [
                    { actions: updateHeatingLocationData, target: 'numberPersonsQuestion', guard: 'isHeatingLocationAvailable', },
                    { actions: updateHeatingLocationData, target: 'heatingLocationNotAvailable', },
                ],
                BACK: { target: 'monumentQuestion', },
            },
        },
        numberPersonsQuestion: {
            on: {
                UPDATE_SELECTED_NUMBER_PERSONS_ANSWER: { actions: updateNumberPersonsData, },
                NEXT: [
                    { actions: updateNumberPersonsData, target: 'plannedReplacementQuestion'},
                ],
                BACK: { target: 'heatingLocationQuestion', },
            },
        },
        plannedReplacementQuestion: {
            on: {
                UPDATE_SELECTED_PLANNED_REPLACEMENT_ANSWER: { actions: updatePlannedReplacementData, },
                NEXT: [
                    { actions: updatePlannedReplacementData, guard: 'isPVQuestionAvailable', target: 'wishPVQuestion', },
                    /*{ actions: updatePlannedReplacementData, guard: 'isAppointmentQuestionAvailable', target: 'appointmentTypeQuestion', },*/
                    { actions: updatePlannedReplacementData, target: 'contactInformationQuestion', },
                ],
                BACK: 'numberPersonsQuestion'
            }
        },
        wishPVQuestion: {
            on: {
                UPDATE_SELECTED_WISH_PV_ANSWER: {actions: updateWishPVData},
                NEXT:
                    [
                        /*{ actions: updateWishPVData, guard: 'isAppointmentQuestionAvailable', target: 'appointmentTypeQuestion', },*/
                        { actions: updateWishPVData, target: 'contactInformationQuestion' },
                    ],
                BACK: 'plannedReplacementQuestion',
            }
        },
        /*
        renovationQuestion: {
            on: {
                UPDATE_SELECTED_RENOVATION_ANSWER: {actions: updateRenovationData},
                NEXT: [
                    { actions: updateRenovationData, guard: 'isRenovationAvailable', target: 'heatingLocationQuestion', },
                    { actions: updateRenovationData, target: 'renovationNotAvailable' },
                ],
                BACK: [
                    { guard: 'isStoredBuildingYearOlderThanMonumentThreshold', target: 'monumentQuestion' },
                    { target: 'buildingAgeQuestion', }
                ],
            }
        },*/

/*
        appointmentTypeQuestion: {
            on: {
                UPDATE_SELECTED_APPOINTMENT_TYPE: {actions: updateAppointmentTypeData},
                NEXT: [
                    { actions: updateAppointmentTypeData, target: 'contactInformationQuestion'},
                ],
                BACK: [
                    {  guard: 'isPVQuestionAvailable', target: 'wishPVQuestion', },
                    { target: 'plannedReplacementQuestion' },
                ],
            }
        },
 */

        contactInformationQuestion: {
            entry: ['setVertriebskanal'],
            on: {
                CONTACT_FORM_SUBMITTED: {
                    actions: [storeContactFormData, transformContactFormDataForApi],
                    target: 'sendingData'
                },
                BACK: [
                    /*{  guard: 'isAppointmentQuestionAvailable', target: 'appointmentTypeQuestion', },*/
                    {  guard: 'isPVQuestionAvailable', target: 'wishPVQuestion', },
                    { target: 'plannedReplacementQuestion' },
                ],
            }
        },
        sendingData: {
            entry: [ clearErrorMessage, 'sendDataAction' ],
            on: {
                VLINK_SUBMISSION_SUCCESS: {
                    target: 'submissionSuccess',
                    actions: [
                        assign({ errorMessage: null }),
                        assign({ apiFieldErrors: null }),
                        assign({ formData: ({ context, event }) => ({ ...context.formData, submissionResultData: event.payload }) }),
                        //redirectParentDirectly
                    ],
                },
                VLINK_SUBMISSION_FAILED: {
                    target: 'contactInformationQuestion',
                    actions: assign({
                        errorMessage: ({ event }) => {
                            console.error('Fehler vom VLINK_SUBMISSION_FAILED Event:', event.error);
                            return event.error.message || 'Ein Fehler ist beim Senden des Kontaktformulars aufgetreten.';
                        },
                        apiFieldErrors: ({ event }) => {
                            return event.error.fieldErrors || null; // Speichert die feldspezifischen Fehler
                        },
                    }),
                },
            },
        },
        submissionSuccess: {
            entry: [
                assign({ errorMessage: null }),
                assign({ apiFieldErrors: null }),
                'trackConversion',
                ],
            on: {
                RESET_WORKFLOW: {
                    target: 'buildingTypeQuestion', // Zurück zum initialen State
                },
            },
        },
        zipCodeNotAvailable: { on: { BACK: 'zipCodeQuestion' } },
        buildingTypeNotAvailable: { on: { BACK: 'buildingTypeQuestion' } },
        ownerNotAvailable: {  on: { BACK: 'ownerQuestion' } },
        //buildingAgeNotAvailable: { on: { BACK: 'buildingAgeQuestion' } },
        buildingYearNotAvailable: {on: {BACK: 'alreadyBuiltQuestion' } },
        monumentNotAvailable: { on: { BACK: 'monumentQuestion' } },
        //renovationNotAvailable: {on: {BACK: 'renovationQuestion'}},
        heatingLocationNotAvailable: {on: {BACK: 'heatingLocationQuestion'}},
    },
}, {
    actions: {
        sendDataAction: (params) => {
            const endpoint = process.env.VUE_APP_ENDPOINT;

            if (endpoint === 'leveto') {
                sendDataToGateway(params);
            } else if (endpoint === 'vlink') {
                sendVlinkDataAction(params);
            } else {
                console.warn(`Unbekannter Endpoint: "${endpoint}". Keine Daten gesendet.`);
            }
        },
        updateBuildingTypeData,
        updateOwnerData,
        storeAddressData,
        //updateBuildingAgeData,
        updateMonumentData,
        //updateRenovationData,
        updateNumberPersonsData,
        updateHeatingLocationData,
        updateWishPVData,
        updateAppointmentTypeData,
        storeContactFormData,
        clearErrorMessage,
        transformContactFormDataForApi,
        setStateHistory,
        sendTrackingPostMessage,
        trackConversion,
        setVertriebskanal: assign(({ context}) => {
            const isFeatureEnabled = process.env.VUE_APP_APPOINTMENT_QUESTION === 'true';
            if (isFeatureEnabled) {
                return;
            }
            const levetoChannel = context.levetoChannel;

            if (levetoChannel !== "ON") {
                return {
                    formData: {
                        ...context.formData,
                        building: { ...(context.formData.building || {}), appointment: 'onsite' }
                    },
                    vertriebskanal: process.env.VUE_APP_VERTRIEBSKANAL,
                };
            }
            return {
                formData: {
                    ...context.formData,
                    building: { ...(context.formData.building || {}), appointment: 'online' }
                },
                vertriebskanal: process.env.VUE_APP_VERTRIEBSKANAL,
            };
        }),
    },
    guards: {
        isZipCodeValid: ({event}) => {
            const inputZipCode = String(event.data.zip);
            return inputZipCode in validZipCodesWP;
        },
        isBuildingTypeAvailable: ({event}) => { const { available } = event.data; return available; },
        isOwnerAvailable: ({event}) => { const { available } = event.data; return available; },
        isAlreadyBuiltAvailable: ({event}) => { const { available } = event.data; return available; },
        isMonumentAvailable: ({event}) => { const { available } = event.data; return available; },
        isRenovationAvailable: ({event}) => { const { available } = event.data; return available; },
        isHeatingLocationAvailable: ({event}) => { const { available } = event.data; return available; },
        isBuildingYearNotAvailable: ({event}) => { const { available } = event.data; return !available; },
        isBuildingOlderThanMonumentThreshold: ({ event }) => {
            const year = parseInt(event.data.value, 10);
            return year < buildingYearThresholds.MONUMENT;
        },
        isStoredBuildingYearOlderThanMonumentThreshold: ({context}) => {
            return context.formData.building.age < buildingYearThresholds.MONUMENT;
            },
        isPVQuestionAvailable: ({context}) => {
            const { zip } = context.formData.building;
            return zip in validZipCodesSolar;
        },
        isAppointmentQuestionAvailable: ({context}) => {
            const isFeatureEnabled = process.env.VUE_APP_APPOINTMENT_QUESTION === 'true';
            if (!isFeatureEnabled) {
                return false;
            }
            return context.levetoChannel !== "ON";
        },

    }
});